import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  ArrowLeftRight,
  Barcode,
  BookOpen,
  BookPlus,
  Boxes,
  ChartColumn,
  ClipboardList,
  Files,
  GraduationCap,
  HandCoins,
  History,
  IdCard,
  LayoutDashboard,
  ListChecks,
  PackagePlus,
  ReceiptText,
  Undo2,
  UserRound,
  Wallet,
} from 'lucide-react';
import styles from './AppLayout.module.css';

// Paths must match the routes declared in App.js
const NAV_SECTIONS = [
  {
    title: null,
    items: [{ to: '/', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    title: 'Billing',
    items: [
      { to: '/bill/new', label: 'New Bill', icon: ReceiptText },
      { to: '/returns', label: 'Return/Exchange', icon: Undo2 },
      { to: '/inter-company', label: 'Inter Company', icon: ArrowLeftRight },
      { to: '/inter-company/bills', label: 'Inter Company Bills', icon: Files },
      { to: '/bills/recent', label: 'Recent Bills', icon: History },
      { to: '/customers/due', label: 'Customer Due List', icon: UserRound },
      { to: '/daily-cash', label: 'Daily Cash', icon: Wallet },
    ],
  },
  {
    title: 'Orders',
    items: [
      { to: '/orders/new', label: 'Customer Order Book', icon: BookPlus },
      { to: '/orders', label: 'View Order Book', icon: BookOpen },
      { to: '/purchase-orders', label: 'Purchase Order', icon: ClipboardList },
    ],
  },
  {
    title: 'Inventory',
    items: [
      { to: '/stock', label: 'View Stock', icon: Boxes },
      { to: '/inventory/add-quantity', label: 'Add Inventory (Qty)', icon: PackagePlus },
      { to: '/inventory/items', label: 'Update Item List', icon: ListChecks },
      { to: '/barcode', label: 'Open Barcode', icon: Barcode },
    ],
  },
  {
    title: 'Reports',
    items: [
      { to: '/cash-collection', label: 'Cash Collection', icon: HandCoins },
      { to: '/reports/sales', label: 'Sale Report', icon: ChartColumn },
      { to: '/reports/school', label: 'School Report', icon: GraduationCap },
      { to: '/salary', label: 'Salary Register', icon: IdCard },
    ],
  },
];

const getNavLinkClass = ({ isActive }) =>
  isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink;

const Sidebar = ({ isOpen, onNavigate }) => (
  <nav
    className={`${styles.sidebar} ${isOpen ? styles.sidebarOpen : ''}`}
    aria-label="Main menu"
  >
    {NAV_SECTIONS.map((section, index) => (
      <div key={section.title || index} className={styles.navSection}>
        {section.title && <p className={styles.navSectionTitle}>{section.title}</p>}
        {section.items.map(({ to, label, icon: Icon }) => (
          // `end` stops /orders from also lighting up on /orders/new
          <NavLink key={to} to={to} end className={getNavLinkClass} onClick={onNavigate}>
            <Icon size={18} aria-hidden="true" />
            <span>{label}</span>
          </NavLink>
        ))}
      </div>
    ))}
  </nav>
);

export default Sidebar;
